import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { ProfilePage } from './ProfilePage';
import { LinkListPage } from './LinkListPage';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
      return <ProfilePage pubkey={decoded.data as string} />;

    case 'nprofile': {
      const data = decoded.data as { pubkey: string; relays?: string[] };
      return <ProfilePage pubkey={data.pubkey} />;
    }

    case 'naddr': {
      const data = decoded.data as { kind: number; pubkey: string; identifier: string };
      return (
        <LinkListPage
          pubkey={data.pubkey}
          identifier={data.identifier}
          kind={data.kind}
        />
      );
    }

    case 'note':
    case 'nevent':
      return <NotFound />;

    default:
      return <NotFound />;
  }
}
